
import { Component, Vue, Watch } from 'vue-property-decorator';
import { UserPermissions, Roles } from "@/config/userPermissions";
import Layouts from '@/layouts';
import BookingStatus from "@/models/booking/bookingStatus";
import { deleteQueryParam } from "@/helpers/route";
const LandingLayout = () => import('@/layouts/landing/LandingLayout.vue');
const ApplicationLayout = () => import('@/layouts/application/ApplicationLayout.vue');
const EntryLayout = () => import('@/layouts/entry/EntryLayout.vue');
const AdminLayout = () => import('@/layouts/admin/AdminLayout.vue');

@Component({
  components: {
    LandingLayout,
    ApplicationLayout,
    EntryLayout,
    AdminLayout
  },
  methods: {
    deleteQueryParam,
  },
  metaInfo: {
    meta: [
        { name: 'robots', content: ((process.env.NODE_ENV === 'production') ? "index" : "noindex") }
    ]
  }
})

export default class App extends Vue {
    public layout = '';
    public layoutComponent = {};

    userPermissions = UserPermissions;
    roles = Roles;
    dispatch = this.$store.dispatch;

    providerId = "";

    whetherToRerender = 0;
    bookingRouteNames: Array<string> = [
        'get-parent-location-automation',
        'parent-location',
        'choose-booking-type',
        'booking-time',
        'reoccurring-booking-day',
        'booking-summary'
    ];
    bookingRouteNamesException: Array<string> = [
        'login'
    ];
    notifications = {
        duration: -1,
        ignoreDuplicates: false
    };

    get provider() {
		const provider = this.$store.getters["booking/getProviderById"](
			this.providerId
		);

		return (provider);
	}

    public async created() {
        this.$root.$on('roleChanged', this.onRoleChanged);
        
        this.layout = this.layoutFromRouteParams();

        this.getLayout(this.layout);
    }

    public beforeDestroy() {
        this.$root.$off('roleChanged', this.onRoleChanged);
    }

    layoutFromRouteParams() {
        let res: string;

        let route: any = (this as any).$route;
        res = route.params.layout ? route.params.layout : route.meta.layout;

        return(res);
    }

    public getLayout (layout: string) {
        switch (layout) {
            case Layouts.entry: {
                this.scrollToWithTimeout(0, 1, 100);
                this.layoutComponent = EntryLayout;

                break;
            }
            case Layouts.landing: {
                this.scrollToWithTimeout(0, 1, 100);
                this.layoutComponent = LandingLayout;

                break;
            }
            case Layouts.application: {
                this.scrollToWithTimeout(0, 1, 100);
                this.layoutComponent = ApplicationLayout;

                break;
            }
            case Layouts.admin:{
                this.scrollToWithTimeout(0, 1, 100);
                this.layoutComponent = AdminLayout;

                break;
            }
            default: {
                this.layoutComponent = ApplicationLayout;
            }
        }
    }

    scrollToWithTimeout(x: number, y: number, timeout: number) {
        setTimeout(function() {
            window.scrollTo(x, y);
        }, timeout);
    }

    onRoleChanged() {
        this.whetherToRerender++;
    }

    processBookingStatus(route: any) {
        var routeName = route.name;
        var routeFullPath = route.fullPath;

        let isBooking: boolean = false;

        if (this.bookingRouteNames.find(x => x == routeName)) {
            isBooking = true;
        }       

        let flagUpdateBookingStatus = false;

        if (isBooking) {
            flagUpdateBookingStatus = true;
        }
        else if (!this.bookingRouteNamesException.find(x => x == routeName)) {
            const bookingStatusStored = this.$store.getters["booking/getBookingStatus"];

            if (bookingStatusStored.isBooking != isBooking) {
                flagUpdateBookingStatus = true;
            }
        }

        if (flagUpdateBookingStatus) {
            let bookingStatus = new BookingStatus();
            bookingStatus.isBooking = isBooking;
            bookingStatus.bookingUrl = routeFullPath;

            this.updateBookingStatus(bookingStatus);
        }
    }

    updateBookingStatus(bookingStatus: BookingStatus) {
        this.$store.dispatch("booking/updateBookingStatus", bookingStatus)
            .catch((error) => console.log(error));
    }

    @Watch('$route')
    public onUrlChanged() {
        this.layout = this.layoutFromRouteParams();
        this.getLayout(this.layout);

        this.processBookingStatus(this.$route);
    }
}
